import dayjs from "dayjs";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const LeadReferralGenericThanks = ({ userName, phoneNumber, dateTime }) => {
  const formattedDateAndTime = dateTime
    ? dayjs(dateTime).subtract(1, "day").format("MMMM D, YYYY [At] hh:mm A")
    : null;

  const parsedPhone = phoneNumber
    ? parsePhoneNumberFromString(phoneNumber)
    : null;

  const FormattedPhone = parsedPhone
    ? `+${parsedPhone.countryCallingCode} (${parsedPhone.nationalNumber.slice(
        0,
        3
      )}) ${parsedPhone.nationalNumber.slice(
        3,
        6
      )}-${parsedPhone.nationalNumber.slice(6)}`
    : "";

  return (
    <div className="thanks_container">
      <h6 className="thanks_heading">{`Thank You, ${userName}!`}</h6>
      <p className="thanks_text mt-3">
        It’s people like <strong>you</strong> who make the world a better place
        — and help spread the word!
      </p>

      <p className="thanks_text">
        We appreciate your referral and are excited to reward you for it!
      </p>

      <p className="thanks_text">
        <strong>
          👉 We will contact you at {FormattedPhone}
          {formattedDateAndTime && ` On ${formattedDateAndTime}`}
        </strong>{" "}
        to arrange your <strong>Referral Reward.</strong>
      </p>

      <p className="thanks_text">
        And don’t stop there — if you have more leads, keep them coming!
      </p>

      <p className="thanks_text">
        Every referral gets you <strong>more rewards</strong> through our{" "}
        <strong>Referral Reward Program.</strong>
      </p>

      <p className="thanks_text">Thank you again for your trust and support!</p>
    </div>
  );
};

export default LeadReferralGenericThanks;
